import {
    CREAR_USUARIO,
    CREAR_USUARIO_EXITO,
    CREAR_USUARIO_ERROR
} from '../types';
import clienteAxios from '../config/axios';

import Swal from 'sweetalert2';
import { setearAlerta } from './alertaActions';

// Crear nuevos usuarios
export function crearNuevoUsuarioAction(usuario) {
    return async (dispatch) => {
        dispatch( crearUsuario() ); 
        try {
            const respuesta = await clienteAxios.post('/usuarios', usuario);
            dispatch( crearUsuarioExito(respuesta.data) );

            //alerta
            Swal.fire({
                icon: 'success',
                title:'Usuario creado con éxito',
                text: 'Se ha enviado un email de confirmación a su casilla de correo',
            }).then(function() {
                window.location = "https://metodoyogen.com/login";
            });

        } catch (error) {

            const mensaje =
                error.response?.data || {
                    msg:
                        'No se pudo crear la cuenta'
                };


            dispatch(
                crearUsuarioError(
                    mensaje
                )
            );


            const alerta = {
                msg:
                    mensaje.msg
            };


            dispatch(
                setearAlerta(
                    alerta
                )
            );


            await Swal.fire({

                icon:
                    'error',

                title:
                    'No se pudo crear la cuenta',

                text:
                    mensaje.msg ||
                    'No se pudo crear la cuenta',

                confirmButtonText:
                    'Entendido',

                confirmButtonColor:
                    '#655EE8'

            });

        }
    }
}

const crearUsuario = () => ({
    type: CREAR_USUARIO,
    payload: true
});

// si el usuario se guarda en la base de datos
const crearUsuarioExito = (token) => ({
    type: CREAR_USUARIO_EXITO,
    payload: token
});

// si hubo un error
const crearUsuarioError = (msg) => ({
    type: CREAR_USUARIO_ERROR,
    payload: msg
});
